import { __read } from "tslib";
import * as PointUtils from '../point';
import * as MatrixUtils from '../matrix';
export function create(point, size) {
    if (point === void 0) { point = PointUtils.create(); }
    if (size === void 0) { size = PointUtils.create(); }
    return {
        point: point,
        size: size,
    };
}
export function expand(rectangle, amount) {
    var amountAsPoint = PointUtils.coerce(amount);
    if (PointUtils.isZero(amountAsPoint))
        return rectangle;
    var point = rectangle.point, size = rectangle.size;
    var newPoint = PointUtils.subtract(point, PointUtils.divide(amountAsPoint, 2));
    var newSize = PointUtils.add(size, amountAsPoint);
    return create(newPoint, newSize);
}
export function getCorners(_a) {
    var point = _a.point, size = _a.size;
    return [
        PointUtils.create(point[0], point[1]),
        PointUtils.create(point[0] + size[0], point[1]),
        PointUtils.create(point[0], point[1] + size[1]),
        PointUtils.create(point[0] + size[0], point[1] + size[1]),
    ];
}
export function getCenter(_a) {
    var point = _a.point, size = _a.size;
    return PointUtils.create(point[0] + size[0] / 2, point[1] + size[1] / 2);
}
export function intersects(_a, _b) {
    var pointA = _a.point, sizeA = _a.size;
    var pointB = _b.point, sizeB = _b.size;
    return !(pointA[0] > pointB[0] + sizeB[0] ||
        pointA[0] + sizeA[0] < pointB[0] ||
        pointA[1] > pointB[1] + sizeB[1] ||
        pointA[1] + sizeA[1] < pointB[1]);
}
export function getMatrixBetween(_a, _b) {
    var pointA = _a.point, sizeA = _a.size;
    var pointB = _b.point, sizeB = _b.size;
    var scaleFactor = PointUtils.divide(sizeB, sizeA);
    return MatrixUtils.translate(MatrixUtils.scale(MatrixUtils.translate(MatrixUtils.create(), pointB), scaleFactor), PointUtils.negate(pointA));
}
// expands the rectangle to the minimum size if it is smaller
export function minSize(rectangle, min) {
    var _a = __read(PointUtils.coerce(min), 2), minWidth = _a[0], minHeight = _a[1];
    var amountToExpand = [
        rectangle.size[0] < minWidth ? minWidth - rectangle.size[0] : 0,
        rectangle.size[1] < minHeight ? minHeight - rectangle.size[1] : 0,
    ];
    return expand(rectangle, amountToExpand);
}
export function unite(_a, _b, out) {
    var point1 = _a.point, size1 = _a.size;
    var point2 = _b.point, size2 = _b.size;
    if (out === void 0) { out = create(); }
    var topLeft = PointUtils.min(point1, point2);
    var bottomRight = PointUtils.max(PointUtils.add(point1, size1), PointUtils.add(point2, size2));
    out.point = topLeft;
    out.size = PointUtils.subtract(bottomRight, topLeft);
    return out;
}
export function uniteAll(rectangles, out) {
    if (out === void 0) { out = create(rectangles[0].point, rectangles[0].size); }
    return rectangles.reduce(function (acc, bounds) { return unite(acc, bounds, acc); }, out);
}
export function scale(rectangle, scaleAmount, center) {
    var scaleMatrix = MatrixUtils.scale(MatrixUtils.create(), scaleAmount, center);
    return transform(rectangle, scaleMatrix);
}
// the bounding box that surrounds the transformed rectangle (not the actual transformed rectangle)
export function transform(rect, matrix) {
    var corners = getCorners(rect).map(function (point) {
        return PointUtils.transform(point, matrix);
    });
    var _a = corners.reduce(function (acc, _a) {
        var _b = __read(_a, 2), x = _b[0], y = _b[1];
        return ({
            minX: Math.min(acc.minX, x),
            minY: Math.min(acc.minY, y),
            maxX: Math.max(acc.maxX, x),
            maxY: Math.max(acc.maxY, y),
        });
    }, {
        minX: Infinity,
        minY: Infinity,
        maxX: -Infinity,
        maxY: -Infinity,
    }), minX = _a.minX, maxX = _a.maxX, minY = _a.minY, maxY = _a.maxY;
    return create([minX, minY], [maxX - minX, maxY - minY]);
}
export function setCenter(_a, center, out) {
    var size = _a.size;
    if (out === void 0) { out = create(undefined, size); }
    out.point = [center[0] - size[0] / 2, center[1] - size[1] / 2];
    return out;
}
export function setSize(_a, size, out) {
    var point = _a.point;
    if (out === void 0) { out = create(point); }
    out.size = size;
    return out;
}
